<template>
  <BaseCompletePage
    premiumBreakdownMonthlyTitle="Monthly Premium Breakdown"
    :content="getTenantsContentCover"
    :sdnData="SDN_DATA_TC"
    :sdnDataAdvised="SDN_DATA_ADVISED_TC"
    :cancellingYourPolicyDescription="'You have the right to cancel your policy within the 14 day cooling off period. After the 14 day cooling off period, you will still have the right to cancel your policy, however you will be charged for the cost of your cover on a pro rata daily basis.'"
    :cardTitle="
      $vuetify.breakpoint.lgAndUp
        ? 'Your Tenant’s Contents Insurance quote'
        : 'Your quote'
    "
  />
</template>

<script>
// SDN dependencies
import { SDN_DATA_TC, SDN_DATA_ADVISED_TC } from "@/constants/sdn.constants";

import BaseCompletePage from "@/views/BaseCompletePage.vue";
import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "CompletePage",
  components: {
    BaseCompletePage,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getTenantsContentCover"]),
  },
  data() {
    return {
      SDN_DATA_TC,
      SDN_DATA_ADVISED_TC,
    };
  },
};
</script>
